var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeraldine3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 291 353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fcdbbc;\n      }\n\n      .cls-2 {\n        fill: #825c41;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        fill: none;\n      }\n\n      .cls-3, .cls-5, .cls-6, .cls-7, .cls-10, .cls-8, .cls-9 {\n        stroke-linecap: round;\n      }\n\n      .cls-3, .cls-5, .cls-6, .cls-7, .cls-10, .cls-9 {\n        stroke-linejoin: round;\n      }\n\n      .cls-3, .cls-7, .cls-8 {\n        stroke-width: 3px;\n      }\n\n      .cls-3, .cls-8 {\n        stroke: #000;\n      }\n\n      .cls-4 {\n        stroke: #42c763;\n        stroke-width: 2px;\n      }\n\n      .cls-4, .cls-8 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-11 {\n        fill: #015e59;\n      }\n\n      .cls-12 {\n        fill: #faf9f8;\n      }\n\n      .cls-13 {\n        fill: #c97c3c;\n      }\n\n      .cls-14 {\n        fill: #f8d9bc;\n      }\n\n      .cls-15 {\n        fill: #414a4c;\n      }\n\n      .cls-16 {\n        fill: #66452e;\n      }\n\n      .cls-17 {\n        fill: #eeb68c;\n      }\n\n      .cls-18 {\n        fill: #b7c8d8;\n      }\n\n      .cls-19 {\n        fill: #063842;\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-22, .cls-10 {\n        fill: #e6eef2;\n      }\n\n      .cls-23 {\n        fill: #fff;\n      }\n\n      .cls-24 {\n        fill: #e3af5b;\n      }\n\n      .cls-25 {\n        fill: #42c763;\n      }\n\n      .cls-5 {\n        stroke: #e6eef2;\n        stroke-width: 11px;\n      }\n\n      .cls-6 {\n        stroke: #073f4a;\n      }\n\n      .cls-6, .cls-10 {\n        stroke-width: 5px;\n      }\n\n      .cls-7, .cls-9 {\n        stroke: #eeb68c;\n      }\n\n      .cls-26 {\n        fill: #0d5359;\n      }\n\n      .cls-27 {\n        fill: #63e06b;\n      }\n\n      .cls-28 {\n        fill: #8ff584;\n      }\n\n      .cls-10 {\n        stroke: #002131;\n      }\n\n      .cls-9 {\n        stroke-width: 2.32px;\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M82.22,150.26h20.26c9.59,0,17.37,7.78,17.37,17.37v7.37c0,3.49-2.83,6.32-6.32,6.32h-42.37c-3.49,0-6.32-2.83-6.32-6.32v-7.37c0-9.59,7.78-17.37,17.37-17.37Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 83.97,
    y: 91.51,
    width: 22.72,
    height: 31.83,
    rx: 11.36,
    ry: 11.36
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 120.94,
    y: 91.51,
    width: 22.72,
    height: 31.83,
    rx: 11.36,
    ry: 11.36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 100,
    cy: 309,
    rx: 68,
    ry: 28
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "167.45 25.7 171.93 23.3 171.98 28.64 167.45 25.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 103.44,
    y: 147.53,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(267.25 311.4) rotate(164.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.01,
    y: 173.63,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(372.23 182.42) rotate(119.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 151.69,
    cy: 204.42,
    r: 14.34
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 92.36,
    y: 200.21,
    width: 22.17,
    height: 65.8,
    rx: 11.09,
    ry: 11.09,
    transform: "translate(206.89 466.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.53,297.82v-42.87c0-6.12-4.96-11.09-11.09-11.09s-11.09,4.96-11.09,11.09v33.75l22.17,9.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 92.36,
    y: 284.5,
    width: 22.17,
    height: 13.32,
    transform: "translate(206.89 582.31) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M97.37,296.54h33.28v13.13h-30.18c-4.48,0-8.11-3.63-8.11-8.11h0c0-2.77,2.25-5.02,5.02-5.02Z",
    transform: "translate(223.01 606.2) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M92.36,188.49h30.4v43.62h-16.02c-7.93,0-14.38-6.44-14.38-14.38v-29.25h0Z",
    transform: "translate(215.11 420.6) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 92.36,
    y: 222.83,
    width: 32.77,
    height: 9.28,
    transform: "translate(217.48 454.95) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 71.96,
    y: 177.76,
    width: 40.79,
    height: 21.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 71.96,
    y: 179.87,
    width: 40.79,
    height: 6.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.36,17.5h0c-26.27,0-49.23,17.73-55.88,43.14l-15.22,58.2c-4.16,15.89,7.84,31.43,24.26,31.43h33.52c46.85,0,81.05-44.29,69.2-89.62h0c-6.65-25.42-29.61-43.14-55.88-43.14Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M82.22,150.26h20.26c9.59,0,17.37,7.78,17.37,17.37v7.37c0,3.49-2.83,6.32-6.32,6.32h-42.37c-3.49,0-6.32-2.83-6.32-6.32v-7.37c0-9.59,7.78-17.37,17.37-17.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M76.3,148.81h32.11v.07c0,6.28-5.1,11.38-11.38,11.38h-9.34c-6.28,0-11.38-5.1-11.38-11.38v-.07h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M72.9,71.11h71.99v40.39c0,21.39-17.37,38.76-38.76,38.76h-18.94c-13.06,0-23.66-10.6-23.66-23.66v-46.12c0-5.17,4.2-9.37,9.37-9.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.67,53.55h25.08c15.53,0,28.14,12.61,28.14,28.14v35.44c0,18.07-14.67,32.74-32.74,32.74h-15.88c-18.07,0-32.74-14.67-32.74-32.74v-35.44c0-15.53,12.61-28.14,28.14-28.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.32,
    y: 135.28,
    width: 24.07,
    height: 17.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.96,44.93h17.74c21.35,0,38.68,17.33,38.68,38.68v1.28h-32.91c-12.98,0-23.51-10.53-23.51-23.51v-16.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M71.96,191.19h40.79v8.88c0,7.41-6.01,13.42-13.42,13.42h-13.95c-7.41,0-13.42-6.01-13.42-13.42v-8.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M118.95,141.92c-7.78,2.53-16.13-1.72-18.67-9.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M115.44,111.35l5.97,16.86c.51,1.44-.56,2.96-2.09,2.96h-2.66c-1.65,0-2.99-1.34-2.99-2.99v-16.52c0-1.02,1.43-1.27,1.77-.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 75.05,
    y: 191.19,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 81.43,
    y: 191.19,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 87.82,
    y: 191.19,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 94.2,
    y: 191.19,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 100.58,
    y: 191.19,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 106.96,
    y: 191.19,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 71.37,
    y: 211.52,
    width: 22.17,
    height: 65.8,
    rx: 11.09,
    ry: 11.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.54,266.26c0-6.12-4.96-11.09-11.09-11.09s-11.09,4.96-11.09,11.09v29.54l22.17,13.33v-42.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M76.34,197.11h23.84v43.62h-38.21v-29.25c0-7.93,6.44-14.38,14.38-14.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 59.59,
    y: 231.45,
    width: 43.85,
    height: 9.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 71.37,
    y: 295.8,
    width: 22.17,
    height: 13.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M76.38,307.84h33.28v13.13h-30.18c-4.48,0-8.11-3.63-8.11-8.11h0c0-2.77,2.25-5.02,5.02-5.02Z",
    transform: "translate(181.03 628.81) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M105.04,201.25h5.03v9.01c0,2.78-2.26,5.03-5.03,5.03h0v-14.05h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 93.33,
    y1: 242.22,
    x2: 93.33,
    y2: 293.68
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 83.97,
    y: 91.51,
    width: 22.72,
    height: 31.83,
    rx: 11.36,
    ry: 11.36
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 91.41,
    y: 100.63,
    width: 12.63,
    height: 21.18,
    rx: 6.31,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 90.44,
    y: 97.29,
    width: 6.91,
    height: 12.59,
    rx: 3.45,
    ry: 3.45
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M83.97,103.07v-.2c0-6.27,5.09-11.36,11.36-11.36h0c6.27,0,11.36,5.09,11.36,11.36v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80.18,
    y1: 99.13,
    x2: 84.21,
    y2: 100.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 81.71,
    y1: 94.81,
    x2: 85.48,
    y2: 96.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 120.94,
    y: 91.51,
    width: 22.72,
    height: 31.83,
    rx: 11.36,
    ry: 11.36
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 128.38,
    y: 100.63,
    width: 12.63,
    height: 21.18,
    rx: 6.31,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 127.41,
    y: 97.29,
    width: 6.91,
    height: 12.59,
    rx: 3.45,
    ry: 3.45
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M120.94,103.07v-.2c0-6.27,5.09-11.36,11.36-11.36h0c6.27,0,11.36,5.09,11.36,11.36v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 147.62,
    y1: 99.13,
    x2: 143.59,
    y2: 100.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 146.08,
    y1: 94.81,
    x2: 142.31,
    y2: 96.82
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.69,115.68h0c6.39,0,11.57,5.19,11.57,11.57v2.04h-10.13c-3.24,0-5.87-2.63-5.87-5.87v-3.32c0-2.44,1.98-4.43,4.43-4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.37,115.68h9.23v5.54c0,4.46-3.62,8.08-8.08,8.08h0c-3.2,0-5.8-2.6-5.8-5.8v-3.16c0-2.57,2.09-4.65,4.65-4.65Z",
    transform: "translate(277.32 244.97) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 171.71,
    y1: 170.36,
    x2: 177.08,
    y2: 174.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 141.86,
    y1: 148.27,
    x2: 169.49,
    y2: 168.62
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 140.37,
    cy: 147.02,
    rx: 3.89,
    ry: 2.62,
    transform: "translate(-62.62 157.8) rotate(-49.36)"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "100.17 231.45 100.17 218.13 105.04 218.13"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 89.95,
    y: 153.7,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(-105.98 200.09) rotate(-66.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.46,
    y: 149.36,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(74.79 387.42) rotate(-129.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 147.44,
    cy: 168.38,
    r: 14.34
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "283.8 202.88 279.32 205.28 279.27 199.94 283.8 202.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "283.8 202.88 171.93 145.16 171.93 23.3 283.8 74.74 283.8 202.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "279.32 205.28 167.45 147.56 167.45 25.7 279.32 77.13 279.32 205.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "273.58 195.44 172.52 143.94 172.52 35.92 273.58 81.84 273.58 195.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 183.79,
    y1: 63.19,
    x2: 215.56,
    y2: 78.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 229.62,
    y1: 83.88,
    x2: 254.38,
    y2: 94.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 183.79,
    y1: 82.41,
    x2: 200.31,
    y2: 89.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 210.6,
    y1: 94.35,
    x2: 239.96,
    y2: 107.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 183.11,
    y1: 101.42,
    x2: 211.32,
    y2: 113.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 224.06,
    y1: 119.52,
    x2: 246.32,
    y2: 129.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 183.11,
    y1: 120.23,
    x2: 201.45,
    y2: 128.6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeraldine3);
export default __webpack_public_path__ + "static/media/geraldine_3.adba9e7960b32c68841c0b9c670737b9.svg";
export { ForwardRef as ReactComponent };